import React, { forwardRef } from 'react';
import Icon, { generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
const draw16px = 'M10.65 13.85a.73.73 0 0 1-.52-.21l-5.29-5.1a.75.75 0 0 1 0-1.08l5.29-5.1a.75.75 0 0 1 1.06 0 .76.76 0 0 1 0 1.06L6.44 8l4.73 4.56a.76.76 0 0 1 0 1.06.78.78 0 0 1-.52.23Z';
const draw24px = 'M15.2,18a.73.73,0,0,1-.52-.21L9.26,12.54a.75.75,0,0,1,0-1.08l5.42-5.23a.75.75,0,1,1,1,1.08L10.86,12l4.86,4.69a.75.75,0,0,1,0,1.06A.78.78,0,0,1,15.2,18Z';
const icons = {
  _16: {
    d: draw16px,
    viewBox: VIEWBOXES._16
  },
  _24: {
    d: draw24px,
    viewBox: VIEWBOXES._24
  }
};
const ChevronLeftIcon = /*#__PURE__*/forwardRef(generateRenderedIcon(icons, 'chevronLeft'));
ChevronLeftIcon.displayName = 'ChevronLeftIcon';
ChevronLeftIcon.propTypes = Icon.propTypes;
ChevronLeftIcon.renderIcon = props => /*#__PURE__*/React.createElement(ChevronLeftIcon, props);
export default ChevronLeftIcon;
//# sourceMappingURL=ChevronLeftIcon.js.map